var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaypal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5306 5.64844H17.3004C20.9348 5.64844 22.3033 7.48823 22.092 10.1956C21.7435 14.6589 19.045 17.1268 15.4658 17.1268H13.6588C13.1682 17.1268 12.8381 17.4511 12.7047 18.3323L11.9294 23.4489C11.879 23.7812 11.7042 23.9764 11.4416 24H7.19667C6.79725 24 6.65515 23.6944 6.7597 23.0326L9.35196 6.61939C9.45582 5.96163 9.81566 5.64844 10.5306 5.64844Z",
    fill: "#009DE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.2977 0H13.0743C14.9829 0 17.2465 0.06196 18.7608 1.3975C19.7724 2.28967 20.3033 3.7111 20.1807 5.23706C19.7651 10.4116 16.6699 13.3098 12.5194 13.3098H9.17718C8.60833 13.3098 8.23126 13.6867 8.07082 14.7076L7.13818 20.6405C7.0777 21.0255 6.91083 21.2523 6.60623 21.2796H2.43183C1.96862 21.2796 1.80393 20.9253 1.92514 20.1578L4.93106 1.12586C5.05152 0.36316 5.4687 0 6.2977 0Z",
    fill: "#113984"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16797 14.1095L9.35144 6.61933C9.4553 5.96157 9.81514 5.64844 10.5301 5.64844H17.2999C18.4206 5.64844 19.326 5.82338 20.0356 6.14586C19.3554 10.7509 16.3769 13.3098 12.4762 13.3098H9.13406C8.69403 13.3098 8.36539 13.5346 8.16797 14.1095Z",
    fill: "#172C70"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.900cfa18.svg";
export { ForwardRef as ReactComponent };